module.exports = __webpack_public_path__ + "media/images/svg/youtube-70d3aff400d65f3b6ba3b08084b8be4e.svg";